/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Countryofbirth2Inputs */

const en__field_countryofbirth2 = /** @type {(inputs: _Field_Countryofbirth2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country of Birth`)
};

const de__field_countryofbirth2 = /** @type {(inputs: _Field_Countryofbirth2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtsland`)
};

/**
* | output |
* | --- |
* | "Country of Birth" |
*
* @param {_Field_Countryofbirth2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_countryofbirth2 = /** @type {((inputs?: _Field_Countryofbirth2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Countryofbirth2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_countryofbirth2(inputs)
	return de__field_countryofbirth2(inputs)
});
export { _field_countryofbirth2 as "_field_countryOfBirth" }